import './sass/index.css';
import './sass/iescss.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Router, browserHistory } from 'react-router';
import routes from './routes';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import './utility/validators';
import * as reducers from './store/reducers';

const currentHostname = document.location.hostname;
var composeEnhancers;

if (
	!process.env.NODE_ENV ||
	process.env.NODE_ENV === 'development' ||
	currentHostname.indexOf('ept-dev.co.uk') !== -1
) {
	composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
} else {
	composeEnhancers = compose;
}

const store = createStore(combineReducers(reducers), composeEnhancers(applyMiddleware(thunk)));

ReactDOM.render(
	<Provider store={store}>
		<Router history={browserHistory} routes={routes} />
	</Provider>,
	document.getElementById('root')
);

//ReactDom.render(<App />,document.getElementById("root"));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js